/** Router location state used to open the org sign-in modal after a public redirect. */
export type OrgLoginNavigationState = {
  openOrgLogin?: boolean;
  returnUrl?: string;
};

export function buildOrgLoginNavigationState(returnUrl: string): OrgLoginNavigationState {
  return { openOrgLogin: true, returnUrl };
}

export function readOrgLoginNavigationState(
  state: unknown
): OrgLoginNavigationState | null {
  if (!state || typeof state !== 'object') return null;
  const candidate = state as OrgLoginNavigationState;
  if (!candidate.openOrgLogin) return null;
  return candidate;
}
